declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
    OR_GA4_CODE: string;
  }
}

export const trackComparisonPhoneSelected = (product: any, position: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'comparison_phone_selected', {
      item_list_id: 'product_comparison',
      item_list_name: 'Product Comparison',
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_category: product.productType || 'phone',
        item_brand: product.brand,
        price: product.price || 0,
        index: position,
      }],
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'comparison_phone_selected',
      product: {
        id: product.id,
        name: product.name,
        brand: product.brand,
        category: product.productType || 'phone',
        price: product.price || 0,
        position: position,
        url: product.url,
      },
    });

  } else {
    console.warn('GA4 not available:', { gtag: !!window.gtag });
  }
};

export const trackComparisonShopNow = (product: any, position: number) => {

  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'comparison_shop_now', {
      content_type: 'product',
      content_id: product.id,
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_category: product.productType || 'phone',
        item_brand: product.brand,
        price: product.price || 0,
        index: position,
      }],
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'comparison_shop_now',
      product: {
        id: product.id,
        name: product.name,
        brand: product.brand,
        category: product.productType || 'phone',
        price: product.price || 0,
        position: position,
        url: product.url,
      },
    });

  } else {
    console.warn('GA4 not available:', { gtag: !!window.gtag });
  }
};

export const trackComparisonFilterSelected = (filterType: string, filterValue: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'comparison_filter_selected', {
      content_type: filterType,
      content_id: filterValue,
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'comparison_filter_selected',
      filter_type: filterType,
      filter_value: filterValue,
    });

  } else {
    console.warn('GA4 not available:', { gtag: !!window.gtag });
  }
};
